import React from 'react'
import { Link } from "react-router-dom";


const UrologyOrthopedics = () => {
    return (
        <>

            <section className="page-title" style={{ backgroundImage: 'url(assets/images/background/3.jpg)' }}>
                <div className="auto-container">
                    <h2>Urology</h2>
                    <ul className="bread-crumb clearfix">
                        <li><Link to="/">Home</Link></li>
                        <li style={{ color: "green" }}>Urology, Orthopedics, Neurology</li>
                    </ul>
                </div>
            </section>


            <div className="sidebar-page-container" style={{ marginTop: "-100px" }}>
                <div className="auto-container">
                    <div className="row clearfix">
                        <div className="content-side col-lg-8 col-md-12 col-sm-12">
                            <div className="blog-detail">
                                <div className="blog-detail_inner">
                                    <div className="blog-detail_three-image">
                                        <img src="assets/img/Urology.jpg" alt />
                                        <a to="assets/img/Urology.jpg" className="lightbox-image news-block_three-search flaticon-search-interface-symbol" />
                                    </div>
                                    <div className="blog-detail_lower-content">
                                        <div className="d-flex flex-wrap">
                                            <div className="blog-detail_date">22 Jun, 2025</div>
                                        </div>
                                        <h3 className="blog-detail_heading">Satna's Leading Neurologist: For Brain & Beyond</h3>
                                        <p> The brain is the command centre of your body. Therefore, if anything goes wrong with the brain, it can significantly impact your health. At Satna Swastik Hospital, we have a dedicated Neurology and Neurosurgery Department, which prioritizes your brain health. Our top neurologists in Satna deliver specialized care for both emergency and chronic neurological conditions for all age groups. The best part? Our hospital is equipped with advanced neurodiagnostic machines and technologies. Here are the conditions our neurologists in Satna diagnose, treat, and manage.</p>

                                        <ul className="list-two">
                                            <li>Stroke, paralysis, and brain hemorrhage</li>
                                            <li>Epilepsy and seizure disorders</li>
                                            <li> Spinal cord injuries and brain tumors </li>
                                            <li> Headaches, migraines, and movement disorders</li>
                                            <li> Nerve compression or neuropathies</li>
                                            <p><b>Wondering why you should choose neurology care in Satna? Here are the reasons:</b></p>
                                            <li> 24×7 stroke management</li>
                                            <li>Neuro-emergency unit </li>
                                            <li>Physiotherapy post-surgery </li>
                                            <p>Additionally, we provide all-encompassing care under one roof, including neurologists, neurosurgeons, and rehabilitation specialists. Thus, get in touch with us right now if you or your loved ones need neurological treatment in Satna!</p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sidebar-side col-lg-4 col-md-12 col-sm-12">
                            <aside className="sidebar sticky-top">
                                <div className="sidebar-widget expert_widget" style={{ backgroundImage: 'url(assets/images/background/pattern-33.png)' }}>
                                    <span className="color-layer" />
                                    <h3>Experienced Team of Doctors, Nurses, and Staff</h3>
                                    <Link to="/appointment" className="theme-btn btn-style-one">
                                        <span className="btn-wrap">
                                            <span className="text-one">Book Appointment</span>
                                            <span className="text-two">Book Appointment</span>
                                        </span>
                                    </Link>
                                    <div className="image">
                                        <img src="assets/images/resource/doctor-1.png" alt />
                                    </div>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default UrologyOrthopedics